import { render, staticRenderFns } from "./EditarObservacao.vue?vue&type=template&id=075cd2b0"
import script from "./EditarObservacao.vue?vue&type=script&lang=ts"
export * from "./EditarObservacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports